import { RESET_STORE } from '../../redux/store';
import {
  ACTIVE_MODAL,
  LOADING_SEARCH_CASES,
  LOADING_VEHICLE_SPOTTED_FORM,
  RDN_CASES,
  SELECTED_CASE,
  VIN,
} from './events';

const INITIAL_STATE = {
  activeModal: null,
  selectedCase: null,
  loadingSearchCases: false,
  loadingVehicleSpottedForm: false,
  rDNCases: [],
  vin: '',
};

export const spottedVehiclesReducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case ACTIVE_MODAL:
      return {
        ...state,
        activeModal: action.payload,
      };
    case SELECTED_CASE:
      return {
        ...state,
        selectedCase: action.payload,
      };
    case RDN_CASES:
      return {
        ...state,
        rDNCases: action.payload,
      };
    case VIN:
      return {
        ...state,
        vin: action.payload,
      };
    case LOADING_SEARCH_CASES:
      return {
        ...state,
        loadingSearchCases: action.payload,
      };
    case LOADING_VEHICLE_SPOTTED_FORM:
      return {
        ...state,
        loadingVehicleSpottedForm: action.payload,
      };
    case RESET_STORE:
      return INITIAL_STATE;
    default:
      return state;
  }
};
